import script from "./elementlist.vue?vue&type=script&lang=ts&setup=true"
export * from "./elementlist.vue?vue&type=script&lang=ts&setup=true"

import "./elementlist.vue?vue&type=style&index=0&id=4c5bf725&lang=scss&scoped=true"
import "./elementlist.vue?vue&type=style&index=1&id=4c5bf725&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4c5bf725"]])

export default __exports__